module.exports = new __parcel__URL__("shop_machines_alchemist_lab.88e02fc2.png").toString();